module.exports = __webpack_public_path__ + "static/media/epay.13a900f8.svg";